import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import { FUNCHESTER_LOGO } from "@/config";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  
  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };
  
  return (
    <nav className="navbar">
      <div className="container navbar-content">
        <Link to="/" className="navbar-logo">
          <img src={FUNCHESTER_LOGO} alt="Funchester TV" className="navbar-logo-img" />
          <span className="navbar-logo-text">
            Funchester <span className="navbar-logo-accent">TV</span>
          </span>
        </Link>
        
        <button className="mobile-menu-btn" onClick={() => setMenuOpen(!menuOpen)} data-testid="mobile-menu-btn">
          <Menu size={24} />
        </button>
        
        <div className={`navbar-nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={`navbar-link ${isActive('/') && location.pathname === '/' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Home
          </Link>
          <Link to="/live" className={`navbar-link ${isActive('/live') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Live
          </Link>
          <Link to="/vault" className={`navbar-link ${isActive('/vault') || isActive('/season') || isActive('/watch') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            The Vault
          </Link>
          <Link to="/donate" className={`navbar-link ${isActive('/donate') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Donate
          </Link>
          <Link to="/admin" className={`navbar-link ${isActive('/admin') ? 'active' : ''}`} onClick={() => setMenuOpen(false)}>
            Admin
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
